/* eslint-disable no-console */

const showClass = 'show-content';
const linkClass = 'menu-link';
const userMenuClass = 'user-menu';
const mobileClass = 'burger-menu';
const bgClass = 'bg-for-usermenu';
const shadowClass = 'header-shadowed';

const mainHeader = document.querySelector('#main-header');
const menuElem = document.querySelectorAll('.dropdown-content');
const menuUser = document.querySelector('.user-menu-container');
const menuMobile = document.querySelector('.menu-mobile-container');

const menuTemplatesTrigger = document.querySelector('.user-menu-item.template');
const menuResponsiveUser = document.querySelector('.responsive-buttons');
const sideContentUser = document.querySelector('.side-content');

let DropDownShowed = null;
let menuTemplateShowed = null;
let triggerMenu = false;
let triggerMobile = false;

// function HANDLE SCROLL
const handleScroll = () => {
  if (triggerMobile) {
    console.log('es movile');
  }
  DropDownShowed.classList.remove(showClass);
  document.documentElement.classList.remove(bgClass);
  mainHeader.classList.remove(bgClass);
  if (menuUser) {
    menuUser.classList.remove(showClass);
  }
  if (menuMobile) {
    menuMobile.classList.remove(showClass);
  }
  document.removeEventListener('scroll', handleScroll);
};

// function HANDLE CLICK
const handleClick = (e) => {
  if (triggerMenu) {
    triggerMenu = false;
    if (menuTemplateShowed) {
      const menuTemplate = document.querySelector('.menu-templates');
      menuTemplate.classList.remove('show-content');
      menuTemplateShowed = null;
    }
    return;
  }
  if (DropDownShowed) {
    DropDownShowed.classList.remove(showClass);
    mainHeader.classList.remove(bgClass);
    document.removeEventListener('scroll', handleScroll);
    if (DropDownShowed.classList.contains(userMenuClass)) {
      document.documentElement.classList.remove(bgClass);
      menuUser.classList.remove(showClass);
    }
    DropDownShowed = null;
    console.log(e);
  }
  if (menuTemplateShowed) {
    if (menuTemplateShowed === 'open') {
      menuTemplateShowed = 'toclose';
    } else if (menuTemplateShowed === 'toclose') {
      if (e.target.classList.contains('menu-templates')) {
        return;
      }
      const menuTemplate = document.querySelector('.menu-templates');
      menuTemplate.classList.remove('show-content');
      menuTemplateShowed = null;
    }
  }
};
// function OPEN MENU USER
const openMenuRespUser = () => (sideContentUser.classList.contains('active')
  ? sideContentUser.classList.remove('active')
  : sideContentUser.classList.add('active'));

// function HANDLE OFFSET MENU
const offsetUserMenu = (triggerMenuElement) => {
  menuUser.style.left = `${triggerMenuElement.getBoundingClientRect().left}px`;
  console.log(triggerMenuElement.getBoundingClientRect().right);
};

const handleTemplateMenu = () => {
  menuTemplateShowed = 'open';
  const menuTemplate = document.querySelector('.menu-templates');
  menuTemplate.classList.add('show-content');
  console.log('Hola');
};

// FOREACH ASIGN FUNCTIONS
[...menuElem].forEach((element) => {
  element.addEventListener('click', (e) => {
    triggerMenu = true;
    // If event element is not a link for dropdown then return.
    /*if (!e.path[0].classList.contains(userMenuClass)) {
      return;
    }*/
    // If element contains showed class then close dropdown.
    // If element is user-menu then clear background page color.
    // If element is burguer-icon then open mobile menu.
    // Then Return.
    if (element.classList.contains(showClass)) {
      if (element.classList.contains(userMenuClass)) {
        // Check if element is user menu then clear background page color.
        document.documentElement.classList.remove(bgClass);
        menuUser.classList.remove(showClass);
      } else if (element.classList.contains(mobileClass)) {
        // Check if element is burguer-icon then close mobile menu.
        document.documentElement.classList.remove(bgClass);
        menuMobile.classList.remove(showClass);
        console.log('burger menu');
        triggerMobile = false;
      }
      element.classList.remove(showClass);
      mainHeader.classList.remove(bgClass);
      return;
    }
    // Check all the elements and clear showed class then add
    // showed class to link element.
    [...menuElem].forEach((melem) => {
      melem.classList.remove(showClass);
    });
    element.classList.add(showClass);
    mainHeader.classList.add(bgClass);
    if (element.classList.contains(userMenuClass)) {
      // Check if element is user-menu then add backgroun-page-color
      offsetUserMenu(element);
      document.documentElement.classList.add(bgClass);
      menuUser.classList.add(showClass);
    } else if (element.classList.contains(mobileClass)) {
      // Check if element is burguer-icon then display mobile menu.
      triggerMobile = true;
      console.log('burger menu');
    }

    // Get Open Element for future checks.
    DropDownShowed = element;
    document.addEventListener('scroll', handleScroll);
  });
});

// EVENT LISTENERS

if (menuTemplatesTrigger) {
  menuTemplatesTrigger.addEventListener('click', handleTemplateMenu);
}
if (menuResponsiveUser) {
  menuResponsiveUser.addEventListener('click', openMenuRespUser);
}

document.addEventListener('click', handleClick);

window.addEventListener('scroll', () => {
  if (document.body.scrollTop > 50 || document.documentElement.scrollTop > 50) {
    mainHeader.classList.add(shadowClass);
  } else {
    mainHeader.classList.remove(shadowClass);
  }
});
